import { render, staticRenderFns } from "./props.vue?vue&type=template&id=3bb1437d&scoped=true"
import script from "./props.vue?vue&type=script&lang=js"
export * from "./props.vue?vue&type=script&lang=js"
import style0 from "./props.vue?vue&type=style&index=0&id=3bb1437d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1437d",
  null
  
)

export default component.exports